import Http from '../core/fetch';
import {
    DOCUMENTS_FETCH_DATA_LOADED,
    DOCUMENTS_FETCH_DATA_STARTED,
    DOCUMENTS_FETCH_DATA_STORE,
    DOCUMENTS_CLEAR_DATA_STORE,
    DOCUMENTS_SHARE_ITEM_INIT,
    DOCUMENTS_SHARE_ITEM_CANCEL,
    DOCUMENTS_SHARE_EMAILS_FETCH_DATA_STORE,
    DOCUMENTS_CLEAR_PURCHASE_MADE,
    DOCUMENTS_LINK_LOADING,
    DOCUMENTS_LINK_LOADING_FINISHED,
} from '../actions/actionsNamesList';

import { addNotification } from '../components/GlobalNotification/globalNotification.actions';

export function setSharePopupState(params) {
    return {
        type: DOCUMENTS_SHARE_ITEM_INIT,
        params
    };
}

export function setShareCancel() {
    return {
        type: DOCUMENTS_SHARE_ITEM_CANCEL
    };
}

function setReceivedEmailsData(data) {
    return {
        type: DOCUMENTS_SHARE_EMAILS_FETCH_DATA_STORE,
        data
    };
}

export function setDocumentsDataLoaded() {
    return {
        type: DOCUMENTS_FETCH_DATA_LOADED
    };
}

export function setDocumentsFetchingData() {
    return {
        type: DOCUMENTS_FETCH_DATA_STARTED
    };
}

export function setReceivedDocumentsData(data) {
    return {
        type: DOCUMENTS_FETCH_DATA_STORE,
        data
    };
}

export function setResetDocumentsData() {
    return {
        type: DOCUMENTS_CLEAR_DATA_STORE
    };
}

export function setFileLoadStart() {
    return {
        type: DOCUMENTS_LINK_LOADING
    };
}

export function setFileLoaded() {
    return {
        type: DOCUMENTS_LINK_LOADING_FINISHED
    };
}

export function setClearDocumentPurchaseMade() {
    return {
        type: DOCUMENTS_CLEAR_PURCHASE_MADE
    };
}

function parseData(data) {
    const result = {};
    const newDocTypes = {
        report: 'Report',
        mac: 'Mac',
        document: 'Document',
        mtdfoodprofile: 'mtdfoodprofile',
        trendspotting: 'Trendspotting'
    };
    data.forEach((elem) => {
        let items;
        if (elem.docType === 'mac') {
            items = elem.items.map((elem) => {
                return {
                    ...elem,
                    thumnailUrl: elem.thumnailUrl.replace(/[^&size=]{3,}$/, '437')
                };
            });
        }
        result[newDocTypes[elem.docType]] = {
            itemsCount: elem.itemsCount,
            thumbnail: elem.thumnailUrl,
            items: items !== undefined ? items : elem.items,
            isFullLoaded: false
        };
    });
    return result;
}

export function getOneDoctypeData(params) {
    return (dispatch, getState) => {
        const justPurchased = getState().documentsData.justPurchased;
        const data = {
            word: params.word || '',
            doctype: params.doctype,
            skip: params.skip || 0,
            take: params.take || 1000,
            time: Date.now(),
        };

        if (!justPurchased){
            dispatch(setDocumentsFetchingData());
        }
        Http.get('documents', data)
            .then((res) => {
                const parsedData = parseData(res);
                if (justPurchased) dispatch(setResetDocumentsData());
                dispatch(setReceivedDocumentsData(parsedData));
                dispatch(setDocumentsDataLoaded());
                if (justPurchased) dispatch(setClearDocumentPurchaseMade());
            })
            .catch((res) => {
                console.error(res);
            });
    };
}

export function getEmailsData() {
    return (dispatch) => {
        Http.get('emails').then((data) => {
            dispatch(setReceivedEmailsData(data));
        });
    };
}

export function shareDocumentLink(data) {
    return (dispatch) => {
        Http.post('post-share', {
            ...data
        }).then(() => {
            dispatch(addNotification({ text: 'Document successfully shared', duration: 5000 }));
        })
        .catch((error) => {
            console.error('!!!error', error);
        });
    };
}
